import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Checkbox,
  Form,
  Row,
  Select,
  Spin,
  Divider,
  TimePicker,
  Radio,
  Input,
  Flex,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import {
  getStockItems,
  submitMaterialRequest,
} from '../../../network/materialRequest';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getWarehouse } from '../../../network/warehouse';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getSearchApi } from '../../../network/itemList';
import {
  addStockEntry,
  getMaterialDetailsInStock,
  getStockEntryDetails,
  updateStockEntry,
} from '../../../network/stockEntry';
import ItemListStockEntry from './ItemListStockEntry';
import ItemListAdditionalCosts from './ItemListAdditionalCosts';
import HeadingApp from '../../../hooks/HeadingApp';
import { MdInventory } from 'react-icons/md';
const AddStockEntry = ({ t, edit, material }) => {
  const [form] = Form.useForm();
  const [selectName, setSelectName] = useState(null);
  const [dataStatus, setDataStatus] = useState(null);
  const [submitButton, setSubmitButton] = useState(false);
  const navigate = useNavigate();
  const { id, idMaterial } = useParams();
  const { companyName } = useSelector((state) => state.user);
  const client = useQueryClient();
  const { message } = App.useApp();
  const [dataSource, setDataSource] = useState([{}]);
  const [dataSourceAdditionalCosts, setDataSourceAdditionalCosts] = useState([
    {},
  ]);
  const [loadingAdd, setLoadingAdd] = useState(false);
  const watchStockEntryType = Form.useWatch('stock_entry_type', form);
  console.log(watchStockEntryType, 'watchStockEntryType');

  const { mutate: onAddStockEntry } = useMutation({
    mutationKey: ['addStockEntry'],
    mutationFn: (body) =>
      edit ? updateStockEntry(body, id) : addStockEntry(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      setSelectName(edit ? id : data?.data?.name);
      setSubmitButton(true);
      message.success(edit ? 'Updated successfully' : 'Added successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getStockEntry] });
      // form.resetFields();
      edit && dataStatus !== 0 && navigate('/stock-entry');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      console.log('error:', error);
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Stock Entry', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500 || !data) {
        message.error(data?.message?.message || 'Error occured');
        return false;
      }
      submitButton && navigate('/stock-entry');
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getStockEntry] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data: stockEntryDetails, isLoading } = useQuery({
    queryKey: [queryKeys.getStockEntry, id],
    queryFn: () => getStockEntryDetails(id),
    enabled: !!edit,
  });
  const { data: stockEntryDetailsName } = useQuery({
    queryKey: [queryKeys.getStockEntryName, selectName],
    queryFn: () => getStockEntryDetails(selectName),
    enabled: !!selectName && !edit,
  });
  const { data: stockEntryDetailsMaterial, isLoading: LoadingDetailsMaterial } =
    useQuery({
      queryKey: [queryKeys.getMaterialDetailsInStock, idMaterial],
      queryFn: () => getMaterialDetailsInStock(idMaterial),
      enabled: !!material,
    });
  const { data: warehouse } = useQuery({
    queryKey: [queryKeys.getWarehouse],
    queryFn: () =>
      getWarehouse({
        key: '',
        value: '',
      }),
    keepPreviousData: true,
  });
  // const { data: itemsList } = useQuery({
  //   queryKey: [queryKeys.getStockItems],
  //   queryFn: () => getStockItems(),
  //   keepPreviousData: true,
  // });
  const filterAccount = ['account_currency'];
  const { data: accounts } = useQuery({
    queryKey: [queryKeys.getAccountSearch],
    queryFn: () => getSearchApi('Account', filterAccount),
    keepPreviousData: true,
  });
  useEffect(() => {
    if (material && stockEntryDetailsMaterial) {
      setDataSource(
        stockEntryDetailsMaterial?.message?.items?.length
          ? stockEntryDetailsMaterial?.message?.items
          : [{}]
      );
      setDataSourceAdditionalCosts(
        stockEntryDetailsMaterial?.message?.additional_costs?.length
          ? stockEntryDetailsMaterial?.message?.additional_costs
          : [{}]
      );
      form.setFieldsValue({
        ...stockEntryDetailsMaterial?.message,
        additional_costs: stockEntryDetailsMaterial?.message?.additional_costs
          ?.length
          ? stockEntryDetailsMaterial?.message?.additional_costs
          : [{}],
        items: stockEntryDetailsMaterial?.message?.items?.length
          ? stockEntryDetailsMaterial?.message?.items
          : [{}],
        posting_date: dayjs(stockEntryDetailsMaterial?.message?.posting_date),
        posting_time: dayjs(
          stockEntryDetailsMaterial?.message?.posting_time,
          'HH:mm'
        ),
      });
    } else {
      form.resetFields();
    }
  }, [edit, stockEntryDetailsMaterial, form]);
  useEffect(() => {
    if (edit && stockEntryDetails) {
      setDataStatus(stockEntryDetails?.data?.docstatus);
      setDataSource(
        stockEntryDetails?.data?.items?.length
          ? stockEntryDetails?.data?.items?.map((item) => ({
              ...item,
              rate: item?.rate || item?.amount,
            }))
          : [{}]
      );
      setDataSourceAdditionalCosts(
        stockEntryDetails?.data?.additional_costs?.length
          ? stockEntryDetails?.data?.additional_costs
          : [{}]
      );
      form.setFieldsValue({
        ...stockEntryDetails?.data,
        additional_costs: stockEntryDetails?.data?.additional_costs?.length
          ? stockEntryDetails?.data?.additional_costs
          : [{}],
        items: stockEntryDetails?.data?.items?.length
          ? stockEntryDetails?.data?.items
          : [{}],
        posting_date: dayjs(stockEntryDetails?.data?.posting_date),
        posting_time: dayjs(stockEntryDetails?.data?.posting_time, 'HH:mm'),
      });
    } else {
      form.resetFields();
    }
  }, [edit, stockEntryDetails, form]);
  useEffect(() => {
    if (!edit && selectName && stockEntryDetailsName) {
      setDataStatus(stockEntryDetailsName?.data?.docstatus);
      setDataSource(
        stockEntryDetailsName?.data?.items?.length
          ? stockEntryDetailsName?.data?.items?.map((item) => ({
              ...item,
              rate: item?.rate || item?.amount,
            }))
          : [{}]
      );
      setDataSourceAdditionalCosts(
        stockEntryDetailsName?.data?.additional_costs?.length
          ? stockEntryDetailsName?.data?.additional_costs
          : [{}]
      );
      form.setFieldsValue({
        ...stockEntryDetailsName?.data,
        additional_costs: stockEntryDetailsName?.data?.additional_costs?.length
          ? stockEntryDetailsName?.data?.additional_costs
          : [{}],
        items: stockEntryDetailsName?.data?.items?.length
          ? stockEntryDetailsName?.data?.items
          : [{}],
        posting_date: dayjs(stockEntryDetailsName?.data?.posting_date),
        posting_time: dayjs(stockEntryDetailsName?.data?.posting_time, 'HH:mm'),
      });
    } else {
      form.resetFields();
    }
  }, [edit, stockEntryDetailsName, form, selectName]);
  const onFinish = (values) => {
    setLoadingAdd(true);

    const SourceWarehouse = dataSource?.some((item) => item?.s_warehouse);
    const TargetWarehouse = dataSource?.some((item) => item?.t_warehouse);

    const stockEntryData = {
      ...values,
      company: companyName,
      is_return: values?.is_return ? 1 : 0,
      posting_date: dayjs(values?.posting_date).format('YYYY-MM-DD'),
      posting_time: dayjs(values?.posting_time).format('HH:mm:ss.SSSSSS'),
      items: dataSource?.map((item) => ({ ...item })),
      additional_costs: dataSourceAdditionalCosts?.map((item) => ({ ...item })),
    };

    if (watchStockEntryType === 'Material Issue') {
      if (!SourceWarehouse)
        return message.error('Source warehouse is required');
      onAddStockEntry(stockEntryData);
    } else if (watchStockEntryType === 'Material Transfer') {
      if (!SourceWarehouse || !TargetWarehouse) {
        return message.error('Source and target warehouse are required');
      }
      onAddStockEntry(stockEntryData);
    } else if (watchStockEntryType === 'Material Receipt') {
      if (!TargetWarehouse)
        return message.error('Target warehouse is required');
      onAddStockEntry(stockEntryData);
    } else if (watchStockEntryType === 'Manufacture') {
      if (!SourceWarehouse || !TargetWarehouse) {
        return message.error('Source and target warehouse are required');
      }
      onAddStockEntry(stockEntryData);
    } else {
      return message.error('Invalid stock entry type');
    }
  };

  if (isLoading || LoadingDetailsMaterial) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <>
      {/* <Heading
        title={t.Inventory}
        subTitle={edit ? t.EditStockEntry : t.AddStockEntry}
        path="/stock-entry"
      /> */}
      <HeadingApp
        nameTab={t.Inventory}
        title={t.stockEntry}
        subTitle={edit ? t.EditStockEntry : t.AddStockEntry}
        icon={<MdInventory />}
      />
      <Card style={{ borderRadius: '0' }}>
        <Form
          form={form}
          name="add-stock-entry"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            items: [{}],
            additional_costs: [{}],
          }}
          style={{
            marginTop: '20px',
          }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="stock_entry_type"
                    label={t.stockEntryType}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      placeholder={t.stockEntryType}
                      style={{ width: '100%' }}
                      popupMatchSelectWidth={false}
                      options={[
                        { value: 'Material Issue', label: t.MaterialIssue },
                        {
                          value: 'Material Transfer',
                          label: t.MaterialTransfer,
                        },
                        {
                          value: 'Manufacture',
                          label: t.Manufacture,
                        },
                        {
                          value: 'Material Receipt',
                          label: t.MaterialReceipt,
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="posting_date"
                    label={t.postingDate}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.postingDate}
                      format="YYYY-MM-DD"
                      disabledDate={(current) =>
                        current.endOf('d').valueOf() <
                        dayjs().endOf('d').valueOf()
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="posting_time"
                    label={t.postingTime}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <TimePicker
                      style={{ width: '100%' }}
                      placeholder={t.postingTime}
                      format="HH:mm"
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={12}
                  md={8}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="is_return"
                    label={t.isReturn}
                    valuePropName="checked"
                    layout="horizontal"
                    className="margin-bottom-0"
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="total_incoming_value"
                    label={t.totalIncomingValue}
                    hidden={!edit || !selectName}
                  >
                    <Input placeholder={t.totalIncomingValue} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="value_difference"
                    label={t.valueDifference}
                    hidden={!edit || !selectName}
                  >
                    <Input placeholder={t.valueDifference} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="total_additional_costs"
                    label={t.totalAdditionalCosts}
                    hidden={!edit || !selectName}
                  >
                    <Input placeholder={t.totalAdditionalCosts} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="total_amount"
                    label={t.totalAmount}
                    hidden={!edit || !selectName}
                  >
                    <Input placeholder={t.totalAmount} disabled />
                  </Form.Item>
                </Col>
                <Divider orientation="left">{t.items}</Divider>
                {watchStockEntryType !== 'Material Receipt' && (
                  <Col xs={24} md={12} xl={8} xxl={8}>
                    <Form.Item
                      name="from_warehouse"
                      label={t.fromWarehouse}
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Select
                        placeholder={t.fromWarehouse}
                        style={{ width: '100%' }}
                        popupMatchSelectWidth={false}
                        onChange={(value) => {
                          setDataSource(
                            dataSource.map((item) => {
                              return {
                                ...item,
                                s_warehouse: value,
                              };
                            })
                          );
                        }}
                        options={warehouse?.data?.map((item) => ({
                          value: item?.name,
                          label: item?.warehouse_name,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                )}
                {watchStockEntryType === 'Material Transfer' && (
                  <Col xs={24} md={12} xl={8} xxl={8}>
                    <Form.Item
                      name="to_warehouse"
                      label={t.toWarehouse}
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Select
                        placeholder={t.toWarehouse}
                        style={{ width: '100%' }}
                        popupMatchSelectWidth={false}
                        onChange={(value) => {
                          setDataSource(
                            dataSource.map((item) => {
                              return {
                                ...item,
                                t_warehouse: value,
                              };
                            })
                          );
                        }}
                        options={warehouse?.data?.map((item) => ({
                          value: item?.name,
                          label: item?.warehouse_name,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                )}
                {watchStockEntryType === 'Material Receipt' && (
                  <Col xs={24} md={12} xl={8} xxl={8}>
                    <Form.Item
                      name="to_warehouse"
                      label={t.toWarehouse}
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Select
                        placeholder={t.toWarehouse}
                        style={{ width: '100%' }}
                        popupMatchSelectWidth={false}
                        onChange={(value) => {
                          setDataSource(
                            dataSource.map((item) => {
                              return {
                                ...item,
                                t_warehouse: value,
                              };
                            })
                          );
                        }}
                        options={warehouse?.data?.map((item) => ({
                          value: item?.name,
                          label: item?.warehouse_name,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                )}
                <Col span={24} className="items-form-add">
                  {/* <Form.List name="items" style={{ width: '100%' }}>
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <>
                        <Flex
                          key={key}
                          justify="space-between"
                          align="center"
                          gap="5px"
                          style={{
                            width: '100%',
                          }}
                        >
                          <Form.Item
                            name={[name, 'item_code']}
                            label={t.items}
                            style={{
                              width: '100%',
                              marginBottom: '0px',
                            }}
                            {...restField}
                          >
                            <Select
                              placeholder={t.items}
                              style={{ width: '100%' }}
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.label ?? '')
                                  .toLocaleLowerCase()
                                  .includes(input.toLocaleLowerCase())
                              }
                              filterSort={(optionA, optionB) =>
                                (optionA?.label ?? '')
                                  .toLowerCase()
                                  .localeCompare(
                                    (optionB?.label ?? '').toLowerCase()
                                  )
                              }
                              popupMatchSelectWidth={false}
                              options={itemsList?.message?.items?.map(
                                (item) => ({
                                  value: item?.name,
                                  label: item?.item_name,
                                })
                              )}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[name, 's_warehouse']}
                            label={t.SourceWarehouse}
                            rules={[
                              {
                                required: true,
                              },
                            ]}
                            style={{
                              width: '100%',
                              marginBottom: '0px',
                            }}
                          >
                            <Select
                              placeholder={t.SourceWarehouse}
                              style={{ width: '100%' }}
                              popupMatchSelectWidth={false}
                              onChange={(value, option) => {
                                console.log(option, 'option');
                              }}
                              options={warehouse?.data?.map((item) => ({
                                value: item?.name,
                                label: item?.warehouse_name,
                                option: item,
                              }))}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[name, 't_warehouse']}
                            label={t.TargetWarehouse}
                            rules={[
                              {
                                required: true,
                              },
                            ]}
                            style={{
                              width: '100%',
                              marginBottom: '0px',
                            }}
                          >
                            <Select
                              placeholder={t.TargetWarehouse}
                              style={{ width: '100%' }}
                              popupMatchSelectWidth={false}
                              onChange={(value, option) => {
                                console.log(option, 'option');
                              }}
                              options={warehouse?.data?.map((item) => ({
                                value: item?.name,
                                label: item?.warehouse_name,
                                option: item,
                              }))}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[name, 'qty']}
                            style={{
                              width: '100%',
                              marginBottom: '0px',
                            }}
                            {...restField}
                            label={t.quantity}
                          >
                            <Input
                              placeholder={t.quantity}
                              style={{ width: '100%' }}
                              type="number"
                            />
                          </Form.Item>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              fontSize: '15px',
                              margin: '0 10px',
                            }}
                          >
                            {fields.length > 1 && (
                              <Button
                                type="text"
                                onClick={() => remove(name)}
                                danger
                                icon={<MdDelete color="red" />}
                              />
                            )}
                            <Button
                              type="text"
                              onClick={() => add()}
                              icon={<PlusOutlined color="#1890ff" />}
                            />
                          </div>
                        </Flex>
                      </>
                    ))}
                  </>
                )}
              </Form.List> */}
                  <ItemListStockEntry
                    t={t}
                    watchStockEntryType={watchStockEntryType}
                    // itemsList={itemsList}
                    setDataSource={setDataSource}
                    dataSource={dataSource}
                    warehouse={warehouse}
                    form={form}
                  />
                </Col>
                {watchStockEntryType === 'Material Transfer' && (
                  <>
                    <Divider orientation="left">{t.AdditionalCosts}</Divider>
                    <Col span={24} className="items-form-add">
                      <ItemListAdditionalCosts
                        t={t}
                        accounts={accounts}
                        dataSourceAdditionalCosts={dataSourceAdditionalCosts}
                        setDataSourceAdditionalCosts={
                          setDataSourceAdditionalCosts
                        }
                      />
                    </Col>
                  </>
                )}
              </Row>
              <div className="form-btns">
                <Button
                  type="primary"
                  ghost
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  {t.Cancel}
                </Button>
                <Button
                  type="primary"
                  loading={loadingAdd}
                  onClick={() => {
                    if (submitButton) {
                      setLoadingAdd(true);
                      handleSubmit.mutate(selectName);
                    } else {
                      form.submit();
                    }
                  }}
                >
                  {/* {edit ? t.edit : t.submit} */}
                  {submitButton ? t.submit : edit ? t.edit : t.Save}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddStockEntry;
